// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicEngineeeringPapers: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53" fill="currentColor">
            <path
                fill="currentColor"
                d="M582,2233.34453 C582,2234.7918 583.180156,2236.01055 584.691406,2236.08672 C589.649688,2236.34063 600.301564,2237.36641 606.375002,2241.48984 L606.375002,2214.40312 C600.423438,2210.37109 590.123985,2209.28437 585.030626,2209 C583.380236,2208.90859 582,2210.17812 582,2211.7625 L582,2233.34453 Z M630.97344,2209 C625.886175,2209.28925 615.607035,2210.36805 609.736721,2214.39195 C609.635158,2214.40312 609.625002,2214.41328 609.625002,2214.43359 L609.625002,2241.5 C615.722815,2237.39789 626.352347,2236.34468 631.308595,2236.08875 C632.821876,2236.00547 634.000002,2234.78672 634.000002,2233.34453 L634.000002,2211.7625 C634.000002,2210.17812 632.618751,2208.90859 630.97344,2209 Z M617.750002,2199.25 C617.750002,2193.86719 613.382814,2189.5 608.000002,2189.5 C602.617189,2189.5 598.250002,2193.86719 598.250002,2199.25 C598.250002,2204.63281 602.617189,2209 608.000002,2209 C613.382814,2209 617.750002,2204.63281 617.750002,2199.25 Z"
                transform="translate(-582 -2189)"
            />
        </svg>
    );
};

export default React.memo(GraphicEngineeeringPapers);
